/* ==========================================================================
   basis-offer-cover.js
   Logique du composant Bundle lit sécurisé
   Chargé uniquement sur les pages produit contenant la section
   ========================================================================== */

(function() {
  /* --- Variables injectées par Liquid dans le DOM --- */
  var dataEl       = document.getElementById('ap-stepper');
  var DISCOUNT     = parseInt(dataEl.dataset.discountPct, 10) / 100;
  var STEP_COUNT   = 4;
  var MAT_THRESHOLD = parseInt(dataEl.dataset.matThreshold, 10) || 10;
  var DISCOUNT_CODE    = dataEl.dataset.discountCode || '';
  var REDIRECT_URL     = dataEl.dataset.redirectUrl || '';
  var REDIRECT_SOMMIER = dataEl.dataset.redirectSommier || 'lattes';

  var COVER_PRICE = parseInt(dataEl.dataset.coverPrice, 10) || 0;
  var COVER_ID    = parseInt(dataEl.dataset.coverId, 10) || 0;

  /* Formatage centimes → prix affiché */
  function fmt(c) {
    return (c / 100).toFixed(2).replace('.', ',') + '\u00A0\u20AC\u00A0TTC';
  }

  /* Calcul du prix remisé par unité : ceil(price * 90 / 100) */
  function discPrice(priceInCents) {
    return Math.ceil(priceInCents * (1 - DISCOUNT));
  }

  /* --- Sélection housse sommier --- */
  window.apSelectCover = function(input) {
    COVER_PRICE = parseInt(input.dataset.price, 10) || 0;
    COVER_ID    = parseInt(input.value, 10) || 0;
    var el = document.getElementById('ap-cover-price-display');
    if (el) el.innerText = fmt(discPrice(COVER_PRICE));
  };

  /* --- Filtrage housse sommier par taille de lit --- */
  window.apFilterCoverByBed = function() {
    var sel   = document.querySelector('input[name="ap_bed_size"]:checked');
    var btype = sel && sel.value === '2places' ? 'two' : 'one';
    var pills = document.querySelectorAll('#ap-cover-grid .ap-pill-card');
    var first = null;
    pills.forEach(function(p) {
      var isDisabled = p.classList.contains('ap-pill-card--oos');
      var m = p.dataset.coverBedType === btype;
      p.style.display = m ? 'block' : 'none';
      if (m && !first && !isDisabled) first = p;
    });
    if (first) {
      var fi = first.querySelector('input');
      fi.checked = true;
      apSelectCover(fi);
    }
    apUpdateLivePrice();
  };

  /* --- Navigation étapes (timeline) --- */
  function updateNav(active) {
    for (var i = 1; i <= STEP_COUNT; i++) {
      var c = document.getElementById('ap-nav-circle-' + i);
      if (!c) continue;
      if (i < active) {
        c.style.background = '#fff'; c.style.color = '#0018AD'; c.style.borderColor = '#fff'; c.innerHTML = '&#10003;';
      } else if (i === active) {
        c.style.background = '#FF993A'; c.style.color = '#fff'; c.style.borderColor = '#fff'; c.innerHTML = i;
      } else {
        c.style.background = '#0018AD'; c.style.color = 'rgba(255,255,255,.6)'; c.style.borderColor = 'rgba(255,255,255,.35)'; c.innerHTML = i;
      }
    }
    var line = document.getElementById('ap-progress-line');
    if (line) line.style.width = (((active - 1) / (STEP_COUNT - 1)) * 100) + '%';
  }

  /* --- Ouverture du stepper --- */
  window.apOpenStepper = function() {
    var closed  = document.getElementById('ap-header-closed');
    var content = document.getElementById('ap-stepper-content');
    if (!content) return;
    closed.style.display = 'none';
    content.style.display = 'block';
    var tl = document.getElementById('ap-step-nav');
    if (tl) tl.classList.add('ap-timeline--visible');
    updateNav(1);
    apFilterCoverByBed();
    apLockBodyHeight();
    dataEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* --- Navigation par clic sur la timeline --- */
  window.apNavStep = function(n) { if (n < (window._apCurrentStep || 1)) apGoStep(n); };

  /* --- Changement d'étape --- */
  window.apGoStep = function(n) {
    window._apCurrentStep = n;
    document.querySelectorAll('.ap-step-panel').forEach(function(p) { p.classList.remove('ap-step-panel--active'); });
    var panel = document.getElementById('ap-step-' + n);
    if (panel) panel.classList.add('ap-step-panel--active');
    updateNav(n);

    if (n === 2) {
      var sel   = document.querySelector('input[name="ap_bed_size"]:checked').value;
      var btype = sel === '2places' ? 'two' : 'one';
      var pills = document.querySelectorAll('#ap-mat-grid .ap-pill-card');
      var first = null;
      pills.forEach(function(p) {
        var isDisabled = p.classList.contains('ap-pill-card--oos');
        var m = p.dataset.bedType === btype;
        p.style.display = m ? 'block' : 'none';
        if (m && !first && !isDisabled) first = p;
      });
      if (first) { first.querySelector('input').checked = true; }
      var vis  = Array.from(pills).filter(function(p) { return p.style.display !== 'none'; }).length;
      var grid = document.getElementById('ap-mat-grid');
      var sel2 = document.getElementById('ap-mat-select');
      var mob  = window.innerWidth < 520 || (navigator.maxTouchPoints > 0 && vis > MAT_THRESHOLD);
      if (vis > MAT_THRESHOLD && mob) {
        Array.from(sel2.options).forEach(function(o) { if (!o.value) return; o.hidden = o.dataset.bedType !== btype; });
        var fo = Array.from(sel2.options).find(function(o) { return o.value && !o.hidden && !o.disabled; });
        if (fo) sel2.value = fo.value;
        grid.style.display = 'none'; sel2.style.display = 'block';
      } else { grid.style.display = 'grid'; sel2.style.display = 'none'; }
    }

    if (n === 3) {
      apSetPillowQty(document.querySelector('input[name="ap_bed_size"]:checked').value === '2places' ? 2 : 1);
    }

    if (n === 4) apBuildRecap();
    apUpdateLivePrice();
  };

  /* --- Modale guide des tailles --- */
  window.apOpenGuide  = function(e) { e.preventDefault(); document.getElementById('ap-guide-modal').style.display = 'flex'; };
  window.apCloseGuide = function()  { document.getElementById('ap-guide-modal').style.display = 'none'; };
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') { apCloseGuide(); apCancelRedirect(); } });

  /* --- Modale redirection sommier --- */
  window.apConfirmRedirect = function(e) { e.preventDefault(); document.getElementById('ap-redirect-modal').style.display = 'flex'; };
  window.apCancelRedirect  = function() {
    var other = REDIRECT_SOMMIER === 'lattes' ? 'tapissier' : 'lattes';
    var t = document.querySelector('input[name="ap_sommier_type"][value="' + CSS.escape(other) + '"]');
    if (t) t.checked = true;
    document.getElementById('ap-redirect-modal').style.display = 'none';
  };
  window.apDoRedirect = function() {
    var btn = document.getElementById('ap-redirect-confirm-btn');
    var s = 2; btn.disabled = true; btn.innerText = 'Redirection dans ' + s + ' s...';
    var t = setInterval(function() { s--; if (s <= 0) { clearInterval(t); window.location.href = REDIRECT_URL; } else btn.innerText = 'Redirection dans ' + s + ' s...'; }, 1000);
  };

  /* --- Changement via select mobile (matelas) --- */
  window.apMatSelectChange = function(sel) {
    var r = document.querySelector('input[name="ap_variant_id"][value="' + CSS.escape(sel.value) + '"]');
    if (r) r.checked = true;
    apUpdateLivePrice();
  };

  /* --- Quantité oreillers --- */
  window.apSetPillowQty = function(qty) {
    window._apPillowQty = qty;
    document.getElementById('ap-pillow-qty-1').classList.toggle('ap-qty-btn--active', qty === 1);
    document.getElementById('ap-pillow-qty-2').classList.toggle('ap-qty-btn--active', qty === 2);
    document.getElementById('ap-pillow-qty-text').innerText =
      qty === 2 ? 'Quantité : X2 housses oreiller sélectionnées' : 'Quantité : X1 housse oreiller sélectionnée.';
    apUpdateLivePrice();
  };

  /* --- Mise à jour prix live --- */
  window.apUpdateLivePrice = function() {
    var mi    = document.querySelector('input[name="ap_variant_id"]:checked');
    var pi    = document.querySelector('input[name="ap_pillow_id"]:checked');
    var ms    = document.getElementById('ap-mat-select');
    var mP    = 0;
    var pUnit = 0;
    var pQty  = window._apPillowQty || 1;

    if (mi) { mP = parseInt(mi.dataset.price, 10) || 0; }
    else if (ms && ms.value) { mP = parseInt(ms.options[ms.selectedIndex].dataset.price, 10) || 0; }
    if (pi) { pUnit = parseInt(pi.dataset.price, 10) || 0; }

    var pDiscTotal = discPrice(pUnit) * pQty;
    var pRawTotal  = pUnit * pQty;

    function setBar(bId, sId, pId, rawCover, rawMat, pillowDiscTot, rawSub) {
      var eb = document.getElementById(bId);
      var es = document.getElementById(sId);
      var ep = document.getElementById(pId);
      if (!ep) return;
      if (rawSub > 0) {
        var totDisc = discPrice(rawCover) + discPrice(rawMat) + pillowDiscTot;
        var sav = rawSub - totDisc;
        if (eb) eb.innerText = fmt(rawSub);
        if (es) es.innerText = '- ' + fmt(sav) + ' économies';
        ep.innerText = fmt(totDisc);
        ep.classList.remove('ap-flash');
        void ep.offsetWidth;
        ep.classList.add('ap-flash');
      } else {
        if (eb) eb.innerText = '';
        if (es) es.innerText = '';
        ep.innerText = '-';
      }
    }

    setBar('ap-live-before-1','ap-live-saving-1','ap-live-price-1', COVER_PRICE, 0, 0, COVER_PRICE);
    setBar('ap-live-before-2','ap-live-saving-2','ap-live-price-2', COVER_PRICE, mP, 0, COVER_PRICE + mP);
    setBar('ap-live-before-3','ap-live-saving-3','ap-live-price-3', COVER_PRICE, mP, pDiscTotal, COVER_PRICE + mP + pRawTotal);
  };

  /* --- Construction du récapitulatif (étape 4) --- */
  function apBuildRecap() {
    var mi = document.querySelector('input[name="ap_variant_id"]:checked');
    var pi = document.querySelector('input[name="ap_pillow_id"]:checked');
    var ci = document.querySelector('input[name="ap_cover_id"]:checked');
    var ms = document.getElementById('ap-mat-select');
    if (!mi && ms && ms.value) {
      var o = ms.options[ms.selectedIndex];
      mi = { dataset: { price: o.dataset.price, label: o.dataset.label } };
    }
    if (!mi || !pi) return;

    var qty       = window._apPillowQty || 1;
    var mP        = parseInt(mi.dataset.price, 10);
    var pUnit     = parseInt(pi.dataset.price, 10);
    var pRawTotal = pUnit * qty;

    var coverDisc  = discPrice(COVER_PRICE);
    var matDisc    = discPrice(mP);
    var pillowDisc = discPrice(pUnit) * qty;

    var sub = COVER_PRICE + mP + pRawTotal;
    var tot = coverDisc + matDisc + pillowDisc;
    var sav = sub - tot;

    document.getElementById('ap-recap-cover-label').innerText  = ci ? (ci.dataset.label || '') : '';
    document.getElementById('ap-recap-cover-orig').innerText   = fmt(COVER_PRICE);
    document.getElementById('ap-recap-cover-price').innerText  = fmt(coverDisc);
    document.getElementById('ap-recap-mat-label').innerText    = mi.dataset.label || '';
    document.getElementById('ap-recap-mat-orig').innerText     = fmt(mP);
    document.getElementById('ap-recap-mat-price').innerText    = fmt(matDisc);
    document.getElementById('ap-recap-pillow-qty-badge').innerText = 'X' + qty;
    document.getElementById('ap-recap-pillow-label').innerText = (pi.dataset.label || '') + (qty > 1 ? ' x ' + qty : '');
    document.getElementById('ap-recap-pillow-orig').innerText  = fmt(pRawTotal);
    document.getElementById('ap-recap-pillow-price').innerText = fmt(pillowDisc);
    document.getElementById('ap-total-before').innerText = fmt(sub);
    document.getElementById('ap-total-saving').innerText = '- ' + fmt(sav);
    document.getElementById('ap-total-price').innerText  = fmt(tot);
    document.getElementById('ap-btn-price').innerText    = fmt(tot);
  }

  /* --- Ajout au panier --- */
  document.getElementById('ap-final-add').addEventListener('click', function() {
    var matInput    = document.querySelector('input[name="ap_variant_id"]:checked');
    var pillowInput = document.querySelector('input[name="ap_pillow_id"]:checked');
    var coverInput  = document.querySelector('input[name="ap_cover_id"]:checked');
    var matSelect   = document.getElementById('ap-mat-select');
    var matId       = matInput ? matInput.value : (matSelect ? matSelect.value : null);

    if (!matId || !pillowInput || !coverInput) {
      alert('Veuillez compléter toutes les étapes.');
      return;
    }

    var pillowQty = window._apPillowQty || 1;
    var items = [
      { id: parseInt(coverInput.value, 10),  quantity: 1,         properties: { '_offre': 'Bundle lit sécurisé -10%', '_discount': DISCOUNT_CODE } },
      { id: parseInt(matId, 10),             quantity: 1,         properties: { '_offre': 'Bundle lit sécurisé -10%', '_discount': DISCOUNT_CODE } },
      { id: parseInt(pillowInput.value, 10), quantity: pillowQty, properties: { '_offre': 'Bundle lit sécurisé -10%', '_discount': DISCOUNT_CODE } }
    ];

    var btn = document.getElementById('ap-final-add');
    btn.disabled = true; btn.innerText = 'Ajout en cours...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
    })
    .then(function(r) {
      if (!r.ok) throw new Error();
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: DISCOUNT_CODE })
      });
    })
    .then(function() {
      window.location.href = '/cart?discount=' + DISCOUNT_CODE;
    })
    .catch(function() {
      btn.disabled = false;
      btn.innerText = 'Je profite de l\u2019offre';
      alert('Une erreur est survenue. Veuillez réessayer.');
    });
  });

  /* --- Verrouillage hauteur du body pour éviter les sauts --- */
  function apLockBodyHeight() {
    var body   = document.querySelector('#ap-stepper .ap-body');
    var panels = document.querySelectorAll('#ap-stepper .ap-step-panel');
    if (!body || !panels.length) return;
    panels.forEach(function(p) { p.style.visibility = 'hidden'; p.style.position = 'absolute'; p.classList.add('ap-step-panel--active'); });
    var maxH = 0;
    panels.forEach(function(p) { var h = p.offsetHeight; if (h > maxH) maxH = h; });
    panels.forEach(function(p) { p.style.visibility = ''; p.style.position = ''; p.classList.remove('ap-step-panel--active'); });
    var first = document.getElementById('ap-step-1');
    if (first) first.classList.add('ap-step-panel--active');
    body.style.minHeight = '';
    body.style.paddingBottom = '24px';
  }

  window._apCurrentStep = 1;
})();
